import type { FaireProductEntity } from "../../entity_types/product";

export const p_jcbvkq9pzc: FaireProductEntity = {
  token: "p_jcbvkq9pzc",
  type: "product",
  name: "Tri Pine - Custom - Youth Short Sleeve Tee",
  brandToken: "b_1bd10jxt4j",
  brandName: "MT Brand Apparel",
  imageUrl: "https://cdn.faire.com/fastly/0ca8a18d80401e95f36ef438642f63589cfc31ed954982f6d5bff668fee1db1d.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2f12b570077c4ce3b15fb4364607c69412ea3e1fb015ed4ae76b56862d8b0d1a.png",
    "https://cdn.faire.com/fastly/9a489fd1fb9fd2d32cd6a3459af4e666aa30731bcbf08b27bc8c1d300861e8a5.png"
  ],
  priceDollars: 11,
  description: "Our new Tri Pine graphic can be customized with your location or town. Please leave your customization request in the space provided. Replace Montana, Maine or Vermont with your custom location request.\nOur youth tees are available in three colors and sizes X- Small through X-Large.\n\nOur Youth T-Shirts are manufactured by LAT Apparel and are 100% Cotton.",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:03:50.110Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
